<template>
    <div class="related-user-list gcmcn-card-gradient">
        <user-form
            v-if="displayFormCreateUserView"
            :taker-group="takerGroup"
            :scopes="scopes"
            :user="selectedUser"
            @on-user-created="OnUserCreated"
            @leave-form-view="onLeaveUserForm"
        >
        </user-form>
        <user-reset-password
            v-else-if="displayFormResetUserPassword"
            :user="selectedUser"
            @on-user-updated="displayFormResetUserPassword = false"
            @leave-form-view="displayFormResetUserPassword = false"
        ></user-reset-password>
        <template v-else>

            <el-button
                type="primary"
                class="gcmcn-primary-btn small add-user-btn"
                icon="el-icon-plus"
                @click="onUserCreation">

            </el-button>
            <div class="total-user">
                <div class="value">{{ users.length }} user{{ users.length > 1 ? 's' : '' }}</div>
                <gcmcn-filters
                    :filter-values="[selectedSortType, searchFilter]"
                    @reset-filters="resetFilters"
                    style="margin-top: 25px;"
                >
                    <dropdown
                        name="Sort"
                        :multiple="false"
                        :list="sortTypeList"
                        itemName="name"
                        itemValue="value"
                        :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                        @on-select-item="selectedSortType = $event"
                    ></dropdown>
                    <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
                </gcmcn-filters>
            </div>
            <template v-if="filteredUsers.length > 0">
                <relatedUser
                    v-for="(user, index) in filteredUsers"
                    :key="index"
                    :user="user"
                    @editUserPassword="onUserChangePassword"
                    @deleteUser="deleteUser"
                ></relatedUser>
            </template>
            <template v-else-if="searchFilter !== ''">
                <p class="list-empty">No user matching this filter</p>
            </template>
        </template>
    </div>
</template>

<script>
import relatedUser from './relatedUser.vue';
import { mapGetters } from 'vuex';
import { GcmcnFilters, Dropdown, SearchFilter } from 'gcmcn-common';
import UserForm from './user-form.vue';
import UserResetPassword from './user-change-password.vue';


export default {

    components: {
        relatedUser,
        GcmcnFilters,
        Dropdown,
        SearchFilter,
        UserForm,
        UserResetPassword,
    },

    props: {
        takerUid: {
            type: String,
            required: true
        }
    },

    data: function(){
        return {
            sortTypeList: [{name: 'asc', value:'asc'}, {name: 'dsc', value:'dsc'}],
            selectedSortType: '',
            searchFilter: '',
            displayFormCreateUserView: false,
            displayFormResetUserPassword: false,
            selectedUser: null,
        };
    },

    computed: {
        ...mapGetters([
            'takersByUid',
            'groupsByUid',
            'usersByUid',
        ]),
        taker(){
            return this.takersByUid(this.takerUid);
        },
        scopes(){
            if(!this.taker){
                return {};
            }
            return this.taker.scopes;
        },
        takerGroup(){
            if(!this.taker){
                return {};
            }
            return this.groupsByUid(this.taker.group_uid);
        },
        users(){
            if(!this.takerGroup || !this.takerGroup.members){
                return {};
            }
            return this.takerGroup.members.map(member => this.usersByUid(member));
        },
        filteredUsers() {
            if (this.searchFilter !== '') {
                return this.users.filter(user => user.email.toLowerCase().includes(this.searchFilter.toLowerCase()));
            } else {
                return this.users;
            }
        }
    },

    mounted: function(){
    },

    methods: {

        resetFilters (){
            this.selectedSortType = '';
            this.$refs.search.clear();
        },
        OnUserCreated(msg){
            this.$store.dispatch('fetchModelByName', 'users').then(() => {
                this.$message({
                    message: msg,
                    type: 'success'
                });
                this.onLeaveUserForm();
            });
        },
        onLeaveUserForm (){
            this.displayFormCreateUserView = false;
        },
        onUserCreation() {
            this.$set(this, 'selectedUser', null);
            this.displayFormCreateUserView = true;
        },
        onUserChangePassword(user) {
            this.$set(this, 'selectedUser', user);
            this.displayFormResetUserPassword = true;
        },
        deleteUser (uid){
            let members = this.takerGroup.members_uid.slice();
            members.splice(members.indexOf(uid), 1);
            this.$store.dispatch('patchItem', {
                item: {
                    uid: this.takerGroup.uid,
                    url: this.takerGroup.url,
                    members_uid: members,
                },
                model: 'groups'
            }).then(() => {
                this.$notify.success({
                    title: 'Success',
                    message: 'User has been deleted'
                });
            }).catch(() => {
                this.$notify.error({
                    title: 'Error',
                    message: 'User couldn\'t be deleted'
                });
            });
        },
    },
};
</script>

<style lang="scss">
.related-user-list {
    .total-user {
        display: flex;
        align-items: center;
        width: 100%;
        font-weight: bold;
        justify-content: space-between;
    }

    .add-user-btn{
        display: flex;
        margin-left: auto;
        i{
            margin-right: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Takers/takerRelatedUserList.vue